import { createClient } from '@supabase/supabase-js';
import type { Database } from '@archi/types/database.generated';

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;
if (!url || !anon) throw new Error('Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY');

export const supabase = createClient<Database>(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'archi-br-auth',
  },
  global: { headers: { 'x-archi-client': 'web' } },
  realtime: { params: { eventsPerSecond: 4 } },
});

export type TypedSupabase = typeof supabase;
